export const FILE_UPLOAD = `mutation ($file: String!, $fileType: String) {
    upload_file(file: $file, file_type: $fileType) {
      message
      url
    }
  }`;
